import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from './AppIcon';
import { useTranslation } from 'react-i18next';

export const createContent = (t) => {
  return {
    common: {
        viewAll: t('common.viewAll'),
        minutesAgo: t('common.minutesAgo'),
    },
    home: {
        tag: t('home.tag'),
        greeting: [
        t('home.greeting_01'),
        t('home.greeting_02'),
        'locally global'
        ],
        weather: {
        maxTemp: t('home.weather.maxTemp'),
        minTemp: t('home.weather.minTemp'),
        morning: t('home.weather.morning'),
        morningWeather: t('home.weather.morningWeather'),
        afternoon: t('home.weather.afternoon'),
        afternoonWeather: t('home.weather.afternoonWeather'),
        fineDust: t('home.weather.fineDust'),
        fineDustLevel: t('home.weather.fineDustLevel'),
        },
        mytown: {
        title: t('home.mytown.title'),
        places: [
            {
            name: t('home.mytown.places.0.name'),
            address: t('home.mytown.places.0.address'),
            },
            {
            name: t('home.mytown.places.1.name'),
            address: t('home.mytown.places.1.address'),
            },
            {
            name: t('home.mytown.places.2.name'),
            address: t('home.mytown.places.2.address'),
            },
        ],
        },
        events: {
        title: t('home.events.title'),
        tag: t('home.tag'),
        post_title: t('home.events.post_title'),
        address: t('home.events.address'),
        date: '2025.12.25 ~ 2025.12.31',
        },
    },

    mingl: [
        {
        category: t('mingl.posts.0.category'),
        title: t('mingl.posts.0.title'),
        content: t('mingl.posts.0.content'),
        author: '진우(Jinu)',
        },
        {
        category: t('mingl.posts.1.category'),
        title: t('mingl.posts.1.title'),
        content: t('mingl.posts.1.content'),
        author: 'Rumy',
        },
        {
        category: t('mingl.posts.2.category'),
        title: t('mingl.posts.2.title'),
        content: t('mingl.posts.2.content'),
        author: '준호(Junho)',
        },
        {
        category: t('mingl.posts.3.category'),
        title: t('mingl.posts.3.title'),
        content: t('mingl.posts.3.content'),
        author: 'Zoey',
        },
        {
        category: t('mingl.posts.4.category'),
        title: t('mingl.posts.4.title'),
        content: t('mingl.posts.4.content'),
        author: '수연(Suyeon)',
        },
        {
        category: t('mingl.posts.5.category'),
        title: t('mingl.posts.5.title'),
        content: t('mingl.posts.5.content'),
        author: '민우(Minwoo)',
        },
        {
        category: t('mingl.posts.6.category'),
        title: t('mingl.posts.6.title'),
        content: t('mingl.posts.6.content'),
        author: 'Abby',
        },
        {
        category: t('mingl.posts.7.category'),
        title: t('mingl.posts.7.title'),
        content: t('mingl.posts.7.content'),
        author: 'Sarah',
        },
    ],
    mingl_translation: [
        {
        category: '생활정보',
        title: '금천구청역 순대차 아저씨 어디있나요?',
        content: '진짜 인생순대였는데, 요즘 통 안보이시네요. 어디계신지 모르겠어요',
        author: '진우(Jinu)',
        },
        {
        category: '생활정보',
        title: '독산동 재래시장 장보기 꿀팁',
        content: '독산 전통시장에서 자주 장을 보는데, 요일별로 가격 차이가 좀 있네요. 어떻게 장보는게 좋을까요?',
        author: 'Rumy',
        },
        {
        category: '일상',
        title: '가산디지털단지 근처 점심 뭐 먹을까?',
        content: '오늘따라 메뉴 정하기 너무 힘드네요. 가산역 근처 직장인들은 어떻게 먹고 있나요?',
        author: '준호(Junho)',
        },
        {
        category: '취미/모임',
        title: '가산역 보드게임 모임 사람 구해요',
        content: '매주 금요일 저녁에 가산역 근처에서 보드게임 모임을 하고 있습니다. 참여해주실 분 구합니다.',
        author: 'Zoey',
        },
        {
        category: '여행/나들이',
        title: '호암산 둘레길 주말 산책 코스 추천',
        content: '이번 주말에 가볍게 산책할 만한 곳 찾다가 호암산 둘레길을 알게 되었어요. 이번에 제가 발견한 가볍게 산책하듯이 즐길 수 있는 코스를 추천합니다',
        author: '수연(Suyeon)',
        },
        {
        category: '일상',
        title: '독산동 근처 조용한 카페 추천해주세요',
        content: '독산동에서 조용하게 작업할 수 있는 카페 찾고 있어요. 와이파이 잘 되고 콘센트 있는 곳 있으면 추천 부탁드립니다',
        author: '민우(Minwoo)',
        },
        {
        category: '생활정보',
        title: '가산동 근처 헬스장 추천 부탁드려요',
        content: '가산디지털단지 근처에서 헬스장 다니는 분 계신가요? 월 회비나 시설 좋은 곳 있으면 추천 부탁드립니다',
        author: 'Abby',
        },
        {
        category: '취미/모임',
        title: '관악산 등산 모임 같이 가실 분 구해요',
        content: '이번 주말에 관악산 등산 가려고 하는데 같이 가실 분 구합니다. 초보자 환영이고 편하게 산책하듯이 갈 예정입니다',
        author: 'Sarah',
        },
    ],

    connect: {
        titles : [
        t('connect.titles.0'),
        t('connect.titles.1'),
        t('connect.titles.2'),
        t('connect.titles.3'),
        ],
        posts : [
        {
            category: t('connect.titles.0'),
            title: t('connect.posts.0.title'),
            reward: t('connect.posts.0.reward'),
            reward_detail: t('connect.posts.0.reward_detail'),
            location: t('connect.posts.0.location'),
        },
        {
            category: t('connect.titles.0'),
            title: t('connect.posts.1.title'),
            reward: t('connect.posts.1.reward'),
            reward_detail: t('connect.posts.1.reward_detail'),
            location: t('connect.posts.1.location'),
        },
        {
            category: t('connect.titles.1'),
            title: t('connect.posts.2.title'),
            reward: t('connect.posts.2.reward'),
            reward_detail: t('connect.posts.2.reward_detail'),
            location: t('connect.posts.2.location'),
        },
        {
            category: t('connect.titles.1'),
            title: t('connect.posts.3.title'),
            reward: t('connect.posts.3.reward'),
            reward_detail: t('connect.posts.3.reward_detail'),
            location: t('connect.posts.3.location'),
        },
        {
            category: t('connect.titles.2'),
            title: t('connect.posts.4.title'),
            reward: t('connect.posts.4.reward'),
            reward_detail: t('connect.posts.4.reward_detail'),
            location: t('connect.posts.4.location'),
        },
        {
            category: t('connect.titles.2'),
            title: t('connect.posts.5.title'),
            reward: t('connect.posts.5.reward'),
            reward_detail: t('connect.posts.5.reward_detail'),
            location: t('connect.posts.5.location'),
        },
        {
            category: t('connect.titles.3.category'),
            title: t('connect.posts.6.title'),
            reward: t('connect.posts.6.reward'),
            reward_detail: t('connect.posts.6.reward_detail'),
            location: t('connect.posts.6.location'),
        },
        {
            category: t('connect.titles.3.category'),
            title: t('connect.posts.7.title'),
            reward: t('connect.posts.7.reward'),
            reward_detail: t('connect.posts.7.reward_detail'),
            location: t('connect.posts.7.location'),
        },
        ]
    },
    connect_translation: {
        viewAll: '전체보기',
        titles : [
        '언어교환',
        '생활적응',
        '중고거래',
        '구인·구직',
        ],
        posts : [
        {
            category: '언어교환',
            title: '한국어-일본어 비즈니스 회화 서로 언어교환하실 분 구해요!',
            reward: '일본어',
            reward_detail: '동일시간 협의',
            location: '성북동 카페',
        },
        {
            category: '언어교환',
            title: '스페인어 원어민 구해요! 대화 연습 도와주세요~',
            reward: '상품권',
            reward_detail: '50,000원 / 건',
            location: '금천구청역',
        },
        {
            category: '생활적응',
            title: '인천공항에서 서울-마포역까지 지하철 안내해 주실 분 구해요',
            reward: '물건',
            reward_detail: '스페인 와인',
            location: '인천공항',
        },
        {
            category: '생활적응',
            title: '원룸 계약서 작성하는데 함께 가실 분 있나요?',
            reward: '현금',
            reward_detail: '10,000원 / 시급',
            location: '서울 영등포 양천역',
        },
        {
            category: '중고거래',
            title: '몽키드라이버 하루만 빌려주세요! 제가 만든 깍두기 한접시 드려요',
            reward: '물건',
            reward_detail: '직접담근 깍두기',
            location: '마포구 서교동',
        },
        {
            category: '중고거래',
            title: '자전거 판매합니다! 사용감 적어요',
            reward: '가격',
            reward_detail: '50,000원',
            location: '신촌역 근처',
        },
        {
            category: '단기 ',
            title: '박람회 단기 알바 모집합니다. 영어 가능자 우대',
            reward: '업무',
            reward_detail: '박람회 현장 지원 및 영어 안내',
            location: '코엑스',
        },
        {
            category: '아르바이트',
            title: '스페인어 가능 바리스타 구합니다. 스페인어 원어민 외국인 우선 채용합니다!',
            reward: '시급',
            reward_detail: '10,000원 부터',
            location: '이태원 카페',
        },
        ]
    },

    passport: {
        introduction: t('passport.introduction'),
        gender: t('passport.gender'),
        gender_detail: t('passport.gender_detail'),
        birth: t('passport.birth'),
        birth_detail: t('passport.birth_detail'),
        nationality: t('passport.nationality'),
        nationality_detail: t('passport.nationality_detail'),
        mother_tongue: t('passport.mother_tongue'),
        mother_tongue_detail: t('passport.mother_tongue_detail'),
        language: t('passport.language'),
        language_detail: [t('passport.language_detail.0'), t('passport.language_detail.1')],
        edit: t('passport.edit'),
        share: t('passport.share'),
    }
  };
};

const MobileDemoPhone = ({ activeScreen = 'home', onScreenChange }) => {
    const { t, i18n } = useTranslation();
    const content = createContent(t);
    
    // 모든 상태를 내부에서 관리
    const [localActiveScreen, setLocalActiveScreen] = React.useState(activeScreen);
    const [isAutoTranslate, setIsAutoTranslate] = React.useState(true);
    const inputBarGapPx = 1;
    const inputBarHeightPx = 48;
    const inputBarRef = React.useRef(null);
    const [messageBottomOffset, setMessageBottomOffset] = React.useState(inputBarHeightPx + inputBarGapPx);
    const outerScrollRef = React.useRef(null);
    const screens = ['home', 'mingl', 'connect', 'talk', 'passport'];

    // Sync with parent activeScreen from scroll
    React.useEffect(() => {
        setLocalActiveScreen(activeScreen);
    }, [activeScreen]);

    React.useLayoutEffect(() => {
        const updateOffsets = () => {
            const h = inputBarRef.current ? inputBarRef.current.getBoundingClientRect().height : 0;
            setMessageBottomOffset(localActiveScreen === 'talk' ? h + inputBarGapPx : 0);
        };
        updateOffsets();
        let ro;
        if (inputBarRef.current) {
            ro = new ResizeObserver(updateOffsets);
            ro.observe(inputBarRef.current);
        }
        return () => {
            if (ro) ro.disconnect();
        };
    }, [localActiveScreen]);

    const handleScreenChange = (screenId) => {
        setLocalActiveScreen(screenId);
        if (onScreenChange) {
            onScreenChange(screenId);
        }
    };

    // Helper component to show chat messages sequentially
    const TalkMessages = ({ isAutoTranslate, outerScrollRef }) => {
        const [step, setStep] = React.useState(0);

        React.useEffect(() => {
            const scheduleMs = [200, 1400, 2600, 3800, 5000];
            const timeouts = scheduleMs.map((ms, i) => setTimeout(() => setStep(i + 1), ms));
            return () => timeouts.forEach((id) => clearTimeout(id));
        }, []);

        React.useEffect(() => {
            const el = outerScrollRef?.current;
            if (!el) return;
            const overflows = el.scrollHeight > el.clientHeight;
            if (overflows) {
                el.scrollTop = el.scrollHeight - el.clientHeight;
            }
        }, [step, outerScrollRef]);

        return (
            <motion.div
                className="relative flex-1 pb-14"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
            >
                <div className="space-y-3 pr-1">
                {step >= 1 && (
                    <motion.div className="flex justify-start" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
                        <div className="bg-gray-200 rounded-xl p-3 max-w-[70%]">
                            <p className="text-sm text-gray-900">안녕 Carlos!</p>
                            {isAutoTranslate && (
                                <motion.p
                                    className="text-xs text-gray-500 mt-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    ¡Hola Carlos!
                                </motion.p>
                            )}
                        </div>
                    </motion.div>
                )}
                {step >= 2 && (
                    <motion.div className="flex justify-start" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
                        <div className="bg-gray-200 rounded-xl p-3 max-w-[70%]">
                            <p className="text-sm text-gray-900">서울에서 맛있는 타코집 알아?</p>
                            {isAutoTranslate && (
                                <motion.p
                                    className="text-xs text-gray-500 mt-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    ¿Conoces una taquería buena en Seúl?
                                </motion.p>
                            )}
                        </div>
                    </motion.div>
                )}
                {step >= 3 && (
                    <motion.div className="flex justify-end" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
                        <div className="bg-orange-100 rounded-xl p-3 max-w-[70%]">
                            <p className="text-sm text-gray-900">Voy a Seúl este fin de semana. ¿Vamos juntos?</p>
                            {isAutoTranslate && (
                                <motion.p
                                    className="text-xs text-gray-600 mt-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    이번 주말에 서울 가는데 같이 갈래?
                                </motion.p>
                            )}
                        </div>
                    </motion.div>
                )}
                {step >= 4 && (
                    <motion.div className="flex justify-start" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
                        <div className="bg-gray-200 rounded-xl p-3 max-w-[70%]">
                            <p className="text-sm text-gray-900">좋아! 렛츠고!</p>
                            {isAutoTranslate && (
                                <motion.p
                                    className="text-xs text-gray-500 mt-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    ¡Genial! ¡Vamos!
                                </motion.p>
                            )}
                        </div>
                    </motion.div>
                )}
                {step >= 5 && (
                    <motion.div className="flex justify-end" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
                        <div className="bg-orange-100 rounded-xl p-3 max-w-[70%]">
                            <p className="text-sm text-gray-900">¡Nos vemos pronto!</p>
                            {isAutoTranslate && (
                                <motion.p
                                    className="text-xs text-gray-600 mt-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    곧 보자!
                                </motion.p>
                            )}
                        </div>
                    </motion.div>
                )}
                </div>
            </motion.div>
        );
    };

    const screenContent = {
        home: {
            title: 'Location-Based Services',
            description: 'Discover nearby services tailored to your needs with real-time recommendations.',
            content: (
                <div className="p-4 space-y-4">
                    {/* Header with Location and Actions */}
                    <motion.div
                        className="flex items-center justify-between mb-2"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {/* Left: Location with dropdown */}
                        <div className="flex items-center space-x-1">
                            <Icon name="MapPin" size={16} className="text-orange-500" />
                            <span className="text-sm font-medium text-gray-900">Seoul</span>
                            <Icon name="ChevronDown" size={14} className="text-gray-900" />
                        </div>
                        {/* Right: Search, Bell, Menu */}
                        <div className="flex items-center space-x-3">
                            <Icon name="Search" size={20} className="text-gray-900" />
                            <div className="relative">
                                <Icon name="Bell" size={20} className="text-gray-900" />
                                <div className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></div>
                            </div>
                            <Icon name="Menu" size={20} className="text-gray-900" />
                        </div>
                    </motion.div>

                    {/* Weather Info (Left) and Personalized Greeting (Right) */}
                    <motion.div
                        className="flex justify-between items-center mb-4"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        {/* Personalized Greeting - Right Column */}
                        <div className={`flex flex-col items-start text-left ${i18n.language === 'en' ? 'text-[10px]' : ''}`}>
                            <p className="font-medium text-gray-900">{content.home.greeting[0]}</p>
                            <p className="text-gray-900">{content.home.greeting[1]}</p>
                            <p className="font-medium text-gray-900">{content.home.greeting[2]}</p>
                        </div>
                        {/* Weather Info - Left Column */}
                        <div className="flex flex-row items-start gap-2">
                            <div className="flex flex-col items-center space-x-0 gap-1">
                                <Icon name="Sun" size={18} className="text-yellow-500" />
                                <span className="text-xs text-gray-700">{content.home.weather.maxTemp}</span>
                                <div className="flex flex-col items-center gap-0">
                                    <span className="text-[8px] text-gray-700"><span className="font-semibold">{content.home.weather.morning}</span> <span className="font-normal">{content.home.weather.morningWeather}</span></span>
                                    <span className="text-[8px] text-gray-700"><span className="font-semibold">{content.home.weather.fineDust}</span> <span className="font-normal">{content.home.weather.fineDustLevel}</span></span>
                                </div>
                            </div>
                            <div className="flex flex-col items-center space-x-0 gap-1">
                                <Icon name="Cloud" size={18} className="text-gray-500" />
                                <span className="text-xs text-gray-700">{content.home.weather.minTemp}</span>
                                <div className="flex flex-col items-center gap-0">
                                    <span className="text-[8px] text-gray-700"><span className="font-semibold">{content.home.weather.afternoon}</span> <span className="font-normal">{content.home.weather.afternoonWeather}</span></span>
                                    <span className="text-[8px] text-gray-700"><span className="font-semibold">{content.home.weather.fineDust}</span> <span className="font-normal">{content.home.weather.fineDustLevel}</span></span>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    {/* Real-time Neighborhood Section */}
                    <motion.div
                        className="space-y-3"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                    >
                        <div className="flex items-center justify-between">
                            <h4 className="font-semibold text-gray-900">{content.home.mytown.title}</h4>
                            <span className="text-[10px] text-gray-500">{content.common.viewAll} &gt;</span>
                        </div>
                        {/* Horizontal Scrollable Cards */}
                        <div className="flex space-x-3 overflow-x-auto pb-2 -mx-4 px-4" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                            {/* Card 1: 은행나무시장 */}
                            <div className="bg-white rounded-xl shadow-sm border flex-shrink-0 w-40">
                                <div className="relative w-full h-32 rounded-t-lg mb-2 overflow-hidden">
                                    <img 
                                        src="/mobile_demo_home_01.png" 
                                        alt="은행나무시장" 
                                        className="w-full h-full object-cover"
                                    />
                                    <div className="absolute bottom-2 left-2 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded">10{content.common.minutesAgo}</div>
                                </div>
                                <div className="px-2 pb-2">
                                    <p className="text-xs font-medium text-gray-900 mb-1 line-clamp-1">{content.home.mytown.places[0].name}</p>
                                    <p className="text-[10px] text-gray-500 line-clamp-1">{content.home.mytown.places[0].address}</p>
                                </div>
                            </div>
                            {/* Card 2: 관악산 */}
                            <div className="bg-white rounded-xl shadow-sm border flex-shrink-0 w-40">
                                <div className="relative w-full h-32 rounded-t-lg mb-2 overflow-hidden">
                                    <img 
                                        src="/mobile_demo_home_03.png" 
                                        alt="관악산" 
                                        className="w-full h-full object-cover"
                                    />
                                    <div className="absolute bottom-2 left-2 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded">14{content.common.minutesAgo}</div>
                                </div>
                                <div className="px-2 pb-2">
                                    <p className="text-xs font-medium text-gray-900 mb-1 line-clamp-1">{content.home.mytown.places[1].name}</p>
                                    <p className="text-[10px] text-gray-500 line-clamp-1">{content.home.mytown.places[1].address}</p>
                                </div>
                            </div>
                            {/* Card 3: 안양천 */}
                            <div className="bg-white rounded-xl shadow-sm border flex-shrink-0 w-40">
                                <div className="relative w-full h-32 rounded-t-lg mb-2 overflow-hidden">
                                    <img 
                                        src="/mobile_demo_home_02.png" 
                                        alt="안양천다목적광장" 
                                        className="w-full h-full object-cover"
                                    />
                                    <div className="absolute bottom-2 left-2 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded">22{content.common.minutesAgo}</div>
                                </div>
                                <div className="px-2 pb-2">
                                    <p className="text-xs font-medium text-gray-900 mb-1 line-clamp-1">{content.home.mytown.places[2].name}</p>
                                    <p className="text-[10px] text-gray-500 line-clamp-1">{content.home.mytown.places[2].address}</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    {/* Neighborhood Events Section */}
                    <motion.div
                        className="space-y-3"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <div className="flex items-center justify-between">
                            <h4 className="font-semibold text-gray-900">{content.home.events.title}</h4>
                            <span className="text-xs text-gray-500">{content.common.viewAll} &gt;</span>
                        </div>
                        {/* Date Selector */}
                        <div className="flex justify-between pb-2 px-2" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                            {['SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI'].map((day, idx) => (
                                <div key={idx} className="flex flex-col items-center flex-shrink-0">
                                    <span className="text-[9px] text-gray-600">{day}</span>
                                    <span className={`text-xs mt-1 ${idx === 1 ? 'text-red-500 font-medium' : idx === 3 ? 'text-gray-900' : 'text-gray-600'}`}>
                                        {8 + idx}
                                    </span>
                                    {idx === 1 && <div className="w-1 h-1 bg-red-500 rounded-full mt-0.5"></div>}
                                </div>
                            ))}
                        </div>
                        {/* Event Card */}
                        <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
                            <div className="relative">
                                <img 
                                    src="/mobile_demo_home_04.png" 
                                    alt="독산동 플리마켓" 
                                    className="w-full h-48 object-cover"
                                />
                                <span className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded">{content.home.events.tag}</span>
                            </div>
                            <div className="p-3">
                                <p className="text-sm font-medium text-gray-900 mb-1 line-clamp-1">{content.home.events.post_title}</p>
                                <p className="text-xs text-gray-500 mb-2 line-clamp-1">{content.home.events.address}</p>
                                <div className="flex items-center space-x-1 text-xs text-gray-500 line-clamp-1">
                                    <Icon name="Calendar" size={12} />
                                    <span>{content.home.events.date}</span>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )
        },
        mingl: {
            title: 'Community Posts',
            description: 'Connect with locals and fellow expats through cultural exchange posts.',
            content: (
                <div className="p-4 space-y-4">
                    {/* Header with Title and Controls */}
                    <motion.div
                        className="flex items-center justify-between"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="flex items-center space-x-1">
                            <Icon name="MapPin" size={16} className="text-orange-500" />
                            <span className="text-sm font-medium text-gray-900">Seoul</span>
                            <Icon name="ChevronDown" size={14} className="text-gray-900" />
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="inline-flex flex-col items-center text-[10px] leading-tight text-text-secondary w-fit">
                                <span className="font-medium">AI</span>
                                <span>Translate</span>
                            </div>
                            <button
                                onClick={() => setIsAutoTranslate((v) => !v)}
                                className={`relative inline-flex items-center h-5 rounded-full px-2 min-w-[52px] transition-colors ${isAutoTranslate ? 'bg-orange-500' : 'bg-gray-300'}`}
                            >
                                <span className={`absolute inset-y-0 flex items-center text-[10px] font-medium pointer-events-none transition-all ${isAutoTranslate ? 'left-2 text-white' : 'left-6 text-gray-700'}`}>
                                    {isAutoTranslate ? 'Auto' : 'off'}
                                </span>
                                <span
                                    className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-all ${isAutoTranslate ? 'right-0.5' : 'left-0.5'}`}
                                />
                            </button>
                        </div>
                    </motion.div>

                    {/* Posts List */}
                    <div className="space-y-0">
                        {/* Post 1 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 pb-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[0].category : content.mingl_translation[0].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[0].title : content.mingl_translation[0].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[0].content : content.mingl_translation[0].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="MapPin" size={12} className="text-red-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[0].author : content.mingl_translation[0].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>20</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500" />
                                        <span>4</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>2</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 2 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[1].category : content.mingl_translation[1].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[1].title : content.mingl_translation[1].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[1].content : content.mingl_translation[1].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="Globe" size={12} className="text-cyan-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[1].author : content.mingl_translation[1].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>48</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500 fill-red-500" />
                                        <span>34</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 3 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[2].category : content.mingl_translation[2].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[2].title : content.mingl_translation[2].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[2].content : content.mingl_translation[2].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="MapPin" size={12} className="text-red-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[2].author : content.mingl_translation[2].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>48</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>11</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 4 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[3].category : content.mingl_translation[3].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[3].title : content.mingl_translation[3].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[3].content : content.mingl_translation[3].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="Globe" size={12} className="text-cyan-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[3].author : content.mingl_translation[3].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>89</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500 fill-red-500" />
                                        <span>12</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>23</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 5 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[4].category : content.mingl_translation[4].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[4].title : content.mingl_translation[4].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[4].content : content.mingl_translation[4].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="Globe" size={12} className="text-cyan-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[4].author : content.mingl_translation[4].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>48</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500 fill-red-500" />
                                        <span>34</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 6 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[5].category : content.mingl_translation[5].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[5].title : content.mingl_translation[5].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[5].content : content.mingl_translation[5].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="MapPin" size={12} className="text-red-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[5].author : content.mingl_translation[5].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>32</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500" />
                                        <span>8</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>5</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 7 */}
                        <motion.div 
                            className="bg-white border-b border-gray-200 py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[6].category : content.mingl_translation[6].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[6].title : content.mingl_translation[6].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[6].content : content.mingl_translation[6].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="MapPin" size={12} className="text-red-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[6].author : content.mingl_translation[6].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>67</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500 fill-red-500" />
                                        <span>15</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>9</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Post 8 */}
                        <motion.div 
                            className="bg-white py-3 relative"
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <span className="text-[10px] text-gray-500 mb-1 block">{isAutoTranslate ? content.mingl[7].category : content.mingl_translation[7].category}</span>
                            <h3 className="text-sm font-semibold text-gray-900 mb-1">{isAutoTranslate ? content.mingl[7].title : content.mingl_translation[7].title}</h3>
                            <p className="text-xs text-gray-500 mb-2 truncate whitespace-nowrap overflow-hidden">{isAutoTranslate ? content.mingl[7].content : content.mingl_translation[7].content}</p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-1">
                                    <Icon name="Globe" size={12} className="text-cyan-500" />
                                    <span className="text-xs text-gray-600">{isAutoTranslate ? content.mingl[7].author : content.mingl_translation[7].author}</span>
                                </div>
                                <div className="flex items-center space-x-3 text-xs text-gray-500">
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Eye" size={12} />
                                        <span>91</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="Heart" size={12} className="text-red-500 fill-red-500" />
                                        <span>28</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <Icon name="MessageCircle" size={12} />
                                        <span>14</span>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            )
        },
        connect: {
            title: 'Service Categories',
            description: 'Access verified local services across all aspects of expat life.',
            content: (
                <div className="relative min-h-full" style={{ background: 'linear-gradient(to bottom,rgb(255, 194, 170),rgb(255, 255, 255))' }}>
                    <div className="p-4 space-y-4">
                        {/* Header with Title and Controls */}
                        <motion.div
                            className="flex items-center justify-between"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="flex items-center space-x-1">
                                <Icon name="MapPin" size={16} className="text-orange-500" />
                                <span className="text-sm font-medium text-gray-900">Seoul</span>
                                <Icon name="ChevronDown" size={14} className="text-gray-900" />
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="inline-flex flex-col items-center text-[10px] leading-tight text-text-secondary w-fit">
                                    <span className="font-medium">AI</span>
                                    <span>Translate</span>
                                </div>
                                <button
                                    onClick={() => setIsAutoTranslate((v) => !v)}
                                    className={`relative inline-flex items-center h-5 rounded-full px-2 min-w-[52px] transition-colors ${isAutoTranslate ? 'bg-orange-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`absolute inset-y-0 flex items-center text-[10px] font-medium pointer-events-none transition-all ${isAutoTranslate ? 'left-2 text-white' : 'left-6 text-gray-700'}`}>
                                        {isAutoTranslate ? 'Auto' : 'off'}
                                    </span>
                                    <span
                                        className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-all ${isAutoTranslate ? 'right-0.5' : 'left-0.5'}`}
                                    />
                                </button>
                            </div>
                        </motion.div>

                        {/* Language Exchange Section */}
                        <motion.div
                            className="space-y-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-bold text-gray-900">{isAutoTranslate ? content.connect.titles[0] : content.connect_translation.titles[0]}</h3>
                                <span className="text-[10px] text-grey-500">{isAutoTranslate ? content.common.viewAll : content.connect_translation.viewAll} &gt;</span>
                            </div>
                            
                            <div className="grid grid-cols-2 gap-3">
                                {/* Left Card */}
                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[0].category : content.connect_translation.posts[0].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[0].title : content.connect_translation.posts[0].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[0].reward : content.connect_translation.posts[0].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[0].reward_detail : content.connect_translation.posts[0].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[0].location : content.connect_translation.posts[0].location}</div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[1].category : content.connect_translation.posts[1].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[1].title : content.connect_translation.posts[1].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[1].reward : content.connect_translation.posts[1].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[1].reward_detail : content.connect_translation.posts[1].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[1].location : content.connect_translation.posts[1].location}</div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Life Adaptation Section */}
                        <motion.div
                            className="space-y-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-bold text-gray-900">{isAutoTranslate ? content.connect.titles[1] : content.connect_translation.titles[1]}</h3>
                                <span className="text-[10px] text-grey-500">{isAutoTranslate ? content.common.viewAll : content.connect_translation.viewAll} &gt;</span>
                            </div>
                            
                            <div className="grid grid-cols-2 gap-3">
                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[2].category : content.connect_translation.posts[2].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[2].title : content.connect_translation.posts[2].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[2].reward : content.connect_translation.posts[2].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[2].reward_detail : content.connect_translation.posts[2].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[2].location : content.connect_translation.posts[2].location}</div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[3].category : content.connect_translation.posts[3].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[3].title : content.connect_translation.posts[3].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[3].reward : content.connect_translation.posts[3].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[3].reward_detail : content.connect_translation.posts[3].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[3].location : content.connect_translation.posts[3].location}</div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Secondhand Trade Section */}
                        <motion.div
                            className="space-y-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-bold text-gray-900">{isAutoTranslate ? content.connect.titles[2] : content.connect_translation.titles[2]}</h3>
                                <span className="text-[10px] text-grey-500">{isAutoTranslate ? content.common.viewAll : content.connect_translation.viewAll} &gt;</span>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[4].category : content.connect_translation.posts[4].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[4].title : content.connect_translation.posts[4].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[4].reward : content.connect_translation.posts[4].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[4].reward_detail : content.connect_translation.posts[4].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[4].location : content.connect_translation.posts[4].location}</div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[5].category : content.connect_translation.posts[5].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[5].title : content.connect_translation.posts[5].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[5].reward : content.connect_translation.posts[5].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[5].reward_detail : content.connect_translation.posts[5].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[5].location : content.connect_translation.posts[5].location}</div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Jobs Section */}
                        <motion.div
                            className="space-y-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-bold text-gray-900">{isAutoTranslate ? content.connect.titles[3] : content.connect_translation.titles[3]}</h3>
                                <span className="text-[10px] text-grey-500">{isAutoTranslate ? content.common.viewAll : content.connect_translation.viewAll} &gt;</span>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[6].category : content.connect_translation.posts[6].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[6].title : content.connect_translation.posts[6].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[6].reward : content.connect_translation.posts[6].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[6].reward_detail : content.connect_translation.posts[6].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[6].location : content.connect_translation.posts[6].location}</div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg p-3 shadow-sm border flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-start justify-between mb-1.5">
                                            <span className="bg-orange-500 text-white text-[8px] px-1 py-0.5 rounded-full">{isAutoTranslate ? content.connect.posts[7].category : content.connect_translation.posts[7].category}</span>
                                            <Icon name="Bookmark" size={16} className="text-gray-400" />
                                        </div>
                                        <h4 className="text-xs font-medium text-gray-900 mb-2 line-clamp-4">
                                            {isAutoTranslate ? content.connect.posts[7].title : content.connect_translation.posts[7].title}
                                        </h4>
                                    </div>
                                    <div>
                                        <div className="text-[8px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[7].reward : content.connect_translation.posts[7].reward}</div>
                                        <div className="text-[10px] text-gray-600 mb-1">{isAutoTranslate ? content.connect.posts[7].reward_detail : content.connect_translation.posts[7].reward_detail}</div>
                                        <div className="text-[8px] text-gray-500">{isAutoTranslate ? content.connect.posts[7].location : content.connect_translation.posts[7].location}</div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            )
        },
        talk: {
            title: 'Chat',
            description: 'Carlos and Jimin are chatting with real-time translation.',
            content: (
                <div className="p-4 space-y-4">
                    {/* Header: Jimin profile (chat with Carlos) */}
                    <motion.div
                        className="sticky top-0 z-10 bg-white flex items-center space-x-3 pb-2 border-b border-border"
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <img src="/avatar_jimin.png" alt="Jimin" className="w-8 h-8 rounded-full object-cover" />
                        <div className="flex-1 leading-tight">
                            <p className="text-sm font-medium">지민 (Jimin)</p>
                            <p className="text-[10px] text-text-secondary flex items-center gap-1">
                                <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span>
                                <span>local friend</span>
                            </p>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="inline-flex flex-col items-center text-[10px] leading-tight text-text-secondary w-fit">
                                <span className="font-medium">AI</span>
                                <span>Translate</span>
                            </div>
                            <button
                                onClick={() => setIsAutoTranslate((v) => !v)}
                                className={`relative inline-flex items-center h-5 rounded-full px-2 min-w-[52px] transition-colors ${isAutoTranslate ? 'bg-orange-500' : 'bg-gray-300'}`}
                            >
                                <span className={`absolute inset-y-0 flex items-center text-[10px] font-medium pointer-events-none transition-all ${isAutoTranslate ? 'left-2 text-white' : 'left-6 text-gray-700'}`}>
                                    {isAutoTranslate ? 'Auto' : 'off'}
                                </span>
                                <span
                                    className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-all ${isAutoTranslate ? 'right-0.5' : 'left-0.5'}`}
                                />
                            </button>
                        </div>
                    </motion.div>

                    {/* Chat Messages - sequential */}
                    <TalkMessages isAutoTranslate={isAutoTranslate} outerScrollRef={outerScrollRef} />
                </div>
            )
        },
        passport: {
            title: 'Cultural Profile',
            description: 'Your digital passport showcasing cultural background and integration journey.',
            content: (
                <div className="relative" style={{ background: 'linear-gradient(to bottom, #ff9f7a, #fff5f0)' }}>
                    {/* Header with Orange Background */}
                    <motion.div
                        className="flex items-center justify-between px-4 p-4 text-white"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        style={{ background: '#ff9f7a' }}
                    >
                        <div className="flex items-center space-x-2">
                            <Icon name="IdCard" size={20} className="text-white" />
                            <span className="text-sm font-medium">PASSPORT</span>
                        </div>
                        <div className="flex items-center space-x-3">
                            <Icon name="Settings" size={20} className="text-white" />
                            <Icon name="Bell" size={20} className="text-white" />
                        </div>
                    </motion.div>

                    {/* Main Profile Card with Semi-circular Top */}
                    <motion.div
                        className="bg-white rounded-t-[2rem] mt-[-0.5rem] pt-6 px-4 pb-3 relative mx-3"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        {/* Profile Summary Section */}
                        <div className="mb-4">
                            {/* Location Icons - Left and Right of Profile Picture */}
                            <div className="flex items-start mb-4">
                                {/* Left Location */}
                                <div className="flex flex-col items-center flex-1">
                                    <Icon name="MapPin" size={20} className="text-red-500 mb-1" />
                                    <span className="text-sm font-bold text-gray-900">Merida</span>
                                    <span className="text-xs text-gray-500 text-center">Mexico</span>
                                </div>
                                
                                {/* Profile Picture with Add Button */}
                                <div className="relative flex flex-col items-center justify-center flex-1">
                                    <div className="w-16 h-16 rounded-full overflow-hidden mx-auto bg-gray-200">
                                        <img 
                                            src="/avatar_carlos.png" 
                                            alt="Carlos" 
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <button className="absolute bottom-0 left-1/2 translate-x-[20px] w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center border-2 border-white">
                                        <Icon name="Plus" size={10} className="text-white" />
                                    </button>
                                </div>
                                
                                {/* Right Location */}
                                <div className="flex flex-col items-center flex-1">
                                    <Icon name="Globe" size={20} className="text-cyan-400 mb-1" />
                                    <span className="text-sm font-bold text-gray-900">Seoul</span>
                                    <span className="text-xs text-gray-500">Korea</span>
                                </div>
                            </div>

                            {/* Name */}
                            <div className="text-center mb-2">
                                <h3 className="text-lg font-bold text-gray-900">까를로스</h3>
                                <p className="text-sm text-gray-600">Carlos</p>
                            </div>

                            {/* Bio/Quote */}
                            <p className="text-sm text-gray-700 text-center mb-4 px-2">
                                {content.passport.introduction}
                            </p>

                            {/* Dotted Separator */}
                            <div className="border-t border-dashed border-gray-300 my-4"></div>
                        </div>

                        {/* Detailed Information Section */}
                        <div className="space-y-3 mb-6">
                            {/* Gender */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <Icon name="User" size={16} className="text-gray-500" />
                                    <span className="text-sm text-gray-600">{content.passport.gender}</span>
                                </div>
                                <span className="text-sm font-medium text-gray-900">{content.passport.gender_detail}</span>
                            </div>

                            {/* Date of Birth */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <Icon name="Calendar" size={16} className="text-gray-500" />
                                    <span className="text-sm text-gray-600">{content.passport.birth}</span>
                                </div>
                                <span className="text-sm font-medium text-gray-900">{content.passport.birth_detail}</span>
                            </div>

                            {/* Nationality */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <Icon name="Flag" size={16} className="text-gray-500" />
                                    <span className="text-sm text-gray-600">{content.passport.nationality}</span>
                                </div>
                                <span className="text-sm font-medium text-gray-900">{content.passport.nationality_detail}</span>
                            </div>

                            {/* Mother Tongue */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <Icon name="MessageSquare" size={16} className="text-gray-500" />
                                    <span className="text-sm text-gray-600">{content.passport.mother_tongue}</span>
                                </div>
                                <span className="text-sm font-medium text-gray-900">{content.passport.mother_tongue_detail}</span>
                            </div>

                            {/* Foreign Languages */}
                            <div className="flex items-start justify-between">
                                <div className="flex items-center space-x-2">
                                    <Icon name="Globe" size={16} className="text-gray-500" />
                                    <span className="text-sm text-gray-600">{content.passport.language}</span>
                                </div>
                                <div className="flex flex-col items-end space-y-1">
                                    <div className="flex items-center space-x-1">
                                        <span className="text-sm font-medium text-gray-900">{content.passport.language_detail[0]}</span>
                                        <div className="flex space-x-0.5">
                                            {[1, 2, 3, 4, 5].map((i) => (
                                                <div key={i} className={`w-2 h-2 ${i <= 4 ? 'bg-blue-500' : 'border border-blue-500'}`} style={{ clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)' }}></div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <span className="text-sm font-medium text-gray-900">{content.passport.language_detail[1]}</span>
                                        <div className="flex space-x-0.5">
                                            {[1, 2, 3, 4, 5].map((i) => (
                                                <div key={i} className={`w-2 h-2 ${i <= 2 ? 'bg-blue-500' : 'border border-blue-500'}`} style={{ clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)' }}></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex space-x-3">
                            <button className="flex-1 py-2.5 rounded-lg bg-white border border-gray-300 text-sm font-medium text-gray-900">
                                {content.passport.edit}
                            </button>
                            <button className="flex-1 py-2.5 rounded-lg bg-white border border-gray-300 text-sm font-medium text-gray-900">
                                {content.passport.share}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )
        }
    };

    return (
        <div className="w-full h-full bg-white rounded-[2.7rem] relative flex flex-col" style={{ overflow: 'hidden' }}>
            {/* Fixed Header - Logo and Status Bar */}
            <div className="flex-shrink-0 bg-white px-5 pt-4 pb-3">
                <div className="flex justify-between items-end">
                    <span className="text-xs text-gray-900">9:41</span>
                    <img
                        src="/logl-logo.png"
                        alt="logl"
                        className="absolute left-1/2 transform -translate-x-1/2"
                        style={{
                            height: '42px',
                            width: 'auto',
                            objectFit: 'contain',
                            clipPath: 'inset(20% 0 20% 0)',
                            transform: 'translateX(-50%) translateY(10px)'
                        }}
                    />
                    <div className="flex items-center space-x-1 text-xs text-gray-900">
                        <Icon name="Wifi" size={12} />
                        <span>100%</span>
                    </div>
                </div>
            </div>

            {/* Screen Content */}
            <div className="flex-1 relative" style={{ overflow: 'hidden' }}>
                <div ref={outerScrollRef} className="absolute left-0 right-0 overflow-y-auto demo-scrollbar" style={{ top: '0px', bottom: Math.max(1, messageBottomOffset - 40), paddingLeft: '0px', paddingRight: '0px' }}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={localActiveScreen}
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -20 }}
                            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                        >
                            {screenContent?.[localActiveScreen]?.content}
                        </motion.div>
                    </AnimatePresence>
                </div>
                {/* Absolute input bar just above footer nav - only show on talk */}
                {localActiveScreen === 'talk' && (
                    <div ref={inputBarRef} className="absolute z-20 pointer-events-auto" style={{ left: '16px', right: '16px', bottom: inputBarGapPx }}>
                        <div className="flex items-center gap-2 pb-3 w-full">
                            <input
                                type="text"
                                placeholder="Type your message..."
                                className="flex-1 min-w-0 h-9 px-3 rounded-full bg-gray-100 text-sm text-gray-900 border-0 outline-none ring-0 focus:ring-0"
                            />
                            <button className="w-8 h-8 shrink-0 p-0 bg-orange-500 rounded-lg flex items-center justify-center leading-none">
                                <Icon name="ArrowUp" size={16} className="text-white" />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer Navigation - Fixed at bottom */}
            <div className="flex-shrink-0 bg-white border-t border-gray-200" style={{ marginBottom: '10px' }}>
                <div className="flex items-center justify-around py-1 px-1">
                    {screens.map((screen) => (
                        <button
                            key={screen}
                            onClick={() => handleScreenChange(screen)}
                            className={`flex flex-col items-center py-0.5 px-2 transition-all ${
                                localActiveScreen === screen ? 'text-orange-500' : 'text-gray-500'
                            }`}
                        >
                            <motion.div
                                className="relative flex flex-col items-center"
                                animate={localActiveScreen === screen ? { y: -2, scale: 1.12 } : { y: 0, scale: 1 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 18 }}
                            >
                                <motion.div
                                    className="absolute -z-10 rounded-xl"
                                    style={{ width: 44, height: 36, left: '50%', top: '50%', transform: 'translate(-50%, -48%)', backgroundColor: 'rgba(255,126,95,0.15)' }}
                                    initial={false}
                                    animate={{ opacity: localActiveScreen === screen ? 1 : 0 }}
                                    transition={{ duration: 0.2 }}
                                />
                                <Icon
                                    name={screen === 'home' ? 'Home' : screen === 'mingl' ? 'Users' : screen === 'connect' ? 'Link' : screen === 'talk' ? 'MessageCircle' : 'User'}
                                    size={18}
                                />
                                <motion.span
                                    className={`text-[10px] mt-0.5 ${localActiveScreen === screen ? 'font-semibold' : ''}`}
                                    animate={localActiveScreen === screen ? { y: -1, scale: 1.05 } : { y: 0, scale: 1 }}
                                    transition={{ type: 'spring', stiffness: 300, damping: 18 }}
                                >
                                    {screen}
                                </motion.span>
                            </motion.div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileDemoPhone;

